<template>
    <div id="app">
        <Header
            :routes="[
                { name: 'Admin Resellers', label: $translate.text('general.dashboard') },
                { name: 'Admin Profiles', label: $translate.text('general.profiles') },
                { name: 'Admin Payments', label: $translate.text('general.payments') },
                { name: 'Admin Requests', label: $translate.text('general.requests') }
            ]"
            :profileRoutes="[
                { name: 'Account', label: $translate.text('auth.my_account') },
                { name: 'Logout', label: $translate.text('auth.logout') }
            ]"
            name="admin"
        />
        <router-view/>
        <Footer
            :routes="[
                { name: 'General About Us', label: $translate.text('nav.footer.about') },
                { name: 'General Conditions', label: $translate.text('nav.footer.conditions') },
                { name: 'General faq', label: $translate.text('nav.footer.help') },
                { name: 'General Contact Us', label: $translate.text('nav.footer.contact') }
            ]"
            name="admin"
            :showLoggedIn="true"
        />
    </div>
</template>
<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Admin',

    components: {
        Header,
        Footer,
    },
};
</script>
